import { uri } from '../../api-endpoint';
import { IUserFromAPISuccessResponse } from '../../type-conversion/user/from-api-response';
import { fetchListTemplateFn } from '../common';

export const fetchUserListAPI = (token: string) =>
  fetchListTemplateFn(token, uri.accountList(), IUserFromAPISuccessResponse);
